<template>
  <div class="content animate-panel" id="content">
    <div style="display: flex; align-items: center; gap: 20px">
      <nav-tabs :tab="tab"></nav-tabs>
    </div>
    <div class="hpanel">
      <tab-content :tab="tab" :banners="banners"></tab-content>
    </div>
  </div>
</template>
<script>
import NavTabs from './NavTabs'
import TabContent from './TabContent'
import ProductService from '@/services/productservice'

export default {
  components: {
    NavTabs,
    TabContent
  },
  data () {
    return {
      tab: null,
      loader: null,
      banners: {
        productListBanner: '',
        productAddBanner: ''
      }
    }
  },
  mounted () {
    this.$events.listen('done', () => {
      this.loader && this.loader.hide()
    })
  },
  watch: {
    $route (to, from) {
      const fromTab = from.params.tab
      const toTab = to.params.tab
      if (fromTab !== toTab && ['list', 'add-by-amazon', 'reports'].includes(toTab)) {
        this.tab = toTab
      } else {
        this.$router.push('/not-found')
      }
    }
  },
  created () {
    this.tab = this.$route.params.tab
    if (['list', 'add-by-amazon', 'reports'].includes(this.tab)) {
      this.loader = this.$loading.show()
      this.getBanners()
    } else {
      this.$router.push('not-found')
    }
  },
  methods: {
    async getBanners () {
      await ProductService.getBanners()
        .then(response => {
          if (response.data) {
            this.banners = response.data
          }
        })
    }
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/productsNew/Products.vue